import {
  assignController, getControllers, controllersAvailable,
  listWithAncestors,
} from '../api/element-manipulation'

assignController('accordionQuickClose', (element) => {

  controllersAvailable( () => {
    const accordion = getControllers(element).accordion
    if ( !accordion ) {
      return
    }
    document.addEventListener('click', (event) => {
      if((element.dataset.accordionExpanded === '1')
        && (listWithAncestors(event.target).indexOf(element) === -1)) {
        accordion.close()
      }
    })
  } )

  return {
    element,
  }
})
